import { render, staticRenderFns } from "./ManagePriorities.vue?vue&type=template&id=2f30ac91&scoped=true"
import script from "./ManagePriorities.vue?vue&type=script&lang=js"
export * from "./ManagePriorities.vue?vue&type=script&lang=js"
import style0 from "./ManagePriorities.vue?vue&type=style&index=0&id=2f30ac91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f30ac91",
  null
  
)

export default component.exports